const GAME_ENTRY_KEY = "cm_game_entry";
const GAME_ACCESS_TOKEN_KEY = "cm_game_access_token";
const GAME_GUEST_TOKEN_KEY = "cm_game_guest_token";
const GAME_PLAYER_KEY = "cm_game_player";
const GAME_PLAYER_OPTIONS_KEY = "cm_game_player_options";

function decodeJwtPayload(token) {
  if (typeof token !== "string") return null;
  const trimmed = token.trim();
  if (!trimmed) return null;

  const parts = trimmed.split(".");
  if (parts.length < 2) return null;

  try {
    const base64 = parts[1].replace(/-/g, "+").replace(/_/g, "/");
    const normalized = base64.padEnd(Math.ceil(base64.length / 4) * 4, "=");
    const json = window.atob(normalized);
    return JSON.parse(json);
  } catch {
    return null;
  }
}

function readJson(key) {
  if (typeof window === "undefined") return null;
  const raw = window.sessionStorage.getItem(key);
  if (!raw) return null;

  try {
    return JSON.parse(raw);
  } catch {
    window.sessionStorage.removeItem(key);
    return null;
  }
}

function writeJson(key, value) {
  if (typeof window === "undefined") return;
  window.sessionStorage.setItem(key, JSON.stringify(value));
}

export function getGameEntry() {
  return readJson(GAME_ENTRY_KEY);
}

export function setGameEntry(game) {
  writeJson(GAME_ENTRY_KEY, game);
}

export function clearGameEntry() {
  if (typeof window === "undefined") return;
  window.sessionStorage.removeItem(GAME_ENTRY_KEY);
}

export function getGameAccessToken() {
  if (typeof window === "undefined") return "";
  return window.sessionStorage.getItem(GAME_ACCESS_TOKEN_KEY) || "";
}

export function getGameAccessTokenPayload() {
  if (typeof window === "undefined") return null;
  return decodeJwtPayload(getGameAccessToken());
}

export function isGameAccessTokenValid(token = getGameAccessToken()) {
  const payload = decodeJwtPayload(token);
  if (!payload?.gameId || payload?.scope !== "game_access") {
    return false;
  }

  if (typeof payload.exp === "number") {
    const nowInSeconds = Math.floor(Date.now() / 1000);
    if (payload.exp <= nowInSeconds) {
      return false;
    }
  }

  return true;
}

export function setGameAccessToken(token) {
  if (typeof window === "undefined") return;
  if (token) window.sessionStorage.setItem(GAME_ACCESS_TOKEN_KEY, token);
  else window.sessionStorage.removeItem(GAME_ACCESS_TOKEN_KEY);
}

export function clearGameAccessToken() {
  if (typeof window === "undefined") return;
  window.sessionStorage.removeItem(GAME_ACCESS_TOKEN_KEY);
}

export function getGameGuestToken() {
  if (typeof window === "undefined") return "";
  return window.sessionStorage.getItem(GAME_GUEST_TOKEN_KEY) || "";
}

export function setGameGuestToken(token) {
  if (typeof window === "undefined") return;
  if (token) window.sessionStorage.setItem(GAME_GUEST_TOKEN_KEY, token);
  else window.sessionStorage.removeItem(GAME_GUEST_TOKEN_KEY);
}

export function clearGameGuestToken() {
  if (typeof window === "undefined") return;
  window.sessionStorage.removeItem(GAME_GUEST_TOKEN_KEY);
}

export function getGamePlayer() {
  return readJson(GAME_PLAYER_KEY);
}

export function setGamePlayer(player) {
  writeJson(GAME_PLAYER_KEY, player);
}

export function clearGamePlayer() {
  if (typeof window === "undefined") return;
  window.sessionStorage.removeItem(GAME_PLAYER_KEY);
}

export function getGamePlayerOptions() {
  return readJson(GAME_PLAYER_OPTIONS_KEY) || [];
}

export function setGamePlayerOptions(players) {
  writeJson(GAME_PLAYER_OPTIONS_KEY, Array.isArray(players) ? players : []);
}

export function clearGamePlayerOptions() {
  if (typeof window === "undefined") return;
  window.sessionStorage.removeItem(GAME_PLAYER_OPTIONS_KEY);
}

export function clearGameSession() {
  clearGameEntry();
  clearGameAccessToken();
  clearGameGuestToken();
  clearGamePlayer();
}
